import { useState } from 'react';
import { useTheme } from '@mui/material';
import { useTimeout } from 'usehooks-ts';

/**
 * Defers a boolean flag until after the drawer's open/close transition has
 * settled, so heavy content isn't mounted or unmounted while the animation
 * is running (which would cause jank).
 *
 * Initialized from `open` so content is shown immediately when the drawer
 * is already open on mount.
 */
export const useDeferredDrawerContent = (open: boolean): boolean => {
  const theme = useTheme();
  const [show, setShow] = useState(open);

  const duration = open
    ? theme.transitions.duration.enteringScreen
    : theme.transitions.duration.leavingScreen;

  // Relies on the enter/exit durations differing so `duration` changes on
  // every toggle, which is what reschedules the timeout.
  useTimeout(() => setShow(open), duration);

  return show;
};
